import { graphql, useStaticQuery } from "gatsby";
    import { PatstoreGroup } from '@types';

const useGetGroup = () => {
    const data = useStaticQuery(graphql`
        query AllGroup {
            allPatstoreGroup {
                edges {
                    node {
                        id
                        
            objectId
    categories
    label
    title
    createdAt
    text
    gallery
    date
    state
    times
    image
    description
    persons
    team
    data
    
                    }
                }
            }
        }
    
        `);


    const allGroup: PatstoreGroup[] =
        data.allPatstoreGroup.edges.map(
            (edge: { node: PatstoreGroup }) => edge.node
        ) || [];

    const findGroup: (id: string) => PatstoreGroup | undefined = (id: string) => {
        const result = allGroup.find((item: PatstoreGroup) => item.objectId === id);

        if (!result) {
            return undefined;
        }

        return result;
    };

    return {
        findGroup,
        groups: allGroup,
    };
}; 

export default useGetGroup;
